// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"64e3f89c","769":"24334cf7"}[chunkId] + ".chunk.js";
};